import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", null, "Title*", -1);
const _hoisted_4 = { class: "col-12" };
import { onBeforeMount, ref, } from "vue";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import { updateCatalogService, addCatalogService, getCatalogServiceById, } from "@/repositories/catalog-service.repository";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import { mandatoryField, maxLength } from "@/shared/utils/validation";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import useFormValidation from "@/shared/composables/useFormValidation";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpsertCatalogService',
    props: {
        serviceId: {}
    },
    emits: ["service-updated"],
    setup(__props, { emit: __emit }) {
        const notify = useToastNotify();
        const emit = __emit;
        const { validationStateDict, invalidForm } = useFormValidation();
        const selectedService = ref({ title: "" });
        const { serviceId } = __props;
        onBeforeMount(async () => await getServiceById());
        const getServiceById = async () => {
            if (serviceId)
                selectedService.value = await getCatalogServiceById(serviceId);
        };
        const onSave = async () => {
            if (invalidForm.value)
                return;
            await createOrUpdateService();
        };
        const createOrUpdateService = async () => {
            try {
                if (serviceId) {
                    await updateCatalogService({
                        id: selectedService.value.id,
                        title: selectedService.value.title,
                    });
                }
                else
                    await addCatalogService(selectedService.value);
                notifyUserAndEmitUpdated(serviceId ? "updated" : "created");
            }
            catch (error) {
                notify("", error.message, "error");
            }
        };
        const notifyUserAndEmitUpdated = (action = "updated") => {
            notify("", `Service : ${selectedService.value.title} has been successfully ${action}`, "success");
            emit("service-updated");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(OneDeskInput, {
                        modelValue: selectedService.value.title,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedService.value.title) = $event)),
                        type: "text",
                        "max-length": 50,
                        rules: [_unref(mandatoryField), _unref(maxLength)(50)],
                        "onUpdate:valid": _cache[1] || (_cache[1] = ($event) => (_unref(validationStateDict).title = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_3
                        ]),
                        _: 1
                    }, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(OneDeskButton, {
                        icon: "pi pi-save",
                        label: "Save",
                        onClick: onSave,
                        disabled: _unref(invalidForm)
                    }, null, 8, ["disabled"])
                ])
            ]));
        };
    }
});
